var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.currentLanguage == 'AR' ? 'rtlText': '']},[_vm._v(_vm._s(_vm.$t("redirecting.text")))])
}
var staticRenderFns = []

export { render, staticRenderFns }